export default "__VITE_ASSET__f2f27835__"